import { createSlice } from '@reduxjs/toolkit';
import {
  addReceiverInfo,
  changeAvatarImage,
  changeUserPassword,
  destroyReceiver,
  fetchCurrentUser,
  hijackUser,
  sendVerifyCode,
  updateUserOnboardStatus,
  verifyReceiverInfo,
} from './account.actions';
import initialState from './account.initialState';

export const accountSlice = createSlice({
  name: 'accountSlice',
  initialState,
  reducers: {
    switchToHijackerUser: (state) => {
      localStorage.setItem('keyPrefix', 'root:');
      state.currentUser = state.hijackerUser;
      state.hijackerUser = {};
      setTimeout(() => {
        window.location.replace('/users');
      }, 0);
    },
    clearCurrentUser: (state) => {
      state.currentUser = {};
      state.hijackerUser = {};
    },
    setCurrentUser: (state, action) => {
      const { currentUser } = action.payload;
      state.currentUser = currentUser;
      state.hijackerUser = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hijackUser.fulfilled, (state, action) => {
        const { hijackedUser, hijackerUser } = action.payload;
        state.currentUser = hijackedUser;
        state.hijackerUser = hijackerUser;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.currentUser.user = {
          ...state.currentUser.user,
          ...action.payload,
        };
      })
      .addCase(changeUserPassword.fulfilled, (state) => {
        state.currentUser.password_expired = false;
      })
      .addCase(updateUserOnboardStatus.fulfilled, (state) => {
        state.currentUser.user.onboarded = true;
      })
      .addCase(changeAvatarImage.pending, (state) => {
        state.changeAvatar.loading = true;
        state.changeAvatar.error = null;
      })
      .addCase(changeAvatarImage.rejected, (state, action) => {
        state.changeAvatar.loading = false;
        state.changeAvatar.error = action.payload;
      })
      .addCase(changeAvatarImage.fulfilled, (state, action) => {
        state.currentUser.user.avatar = action.payload || null;
        state.changeAvatar.loading = false;
        state.changeAvatar.error = null;
      })
      .addCase(addReceiverInfo.pending, (state) => {
        state.addReceiver.loading = true;
        state.addReceiver.error = null;
      })
      .addCase(addReceiverInfo.rejected, (state, action) => {
        state.addReceiver.loading = false;
        state.addReceiver.error = action.payload;
      })
      .addCase(addReceiverInfo.fulfilled, (state, action) => {
        const { data = [], isFromContact } = action?.payload;
        if (isFromContact)
          state.currentUser.user.verified_receivers = [
            ...state.currentUser.user.verified_receivers,
            { ...data },
          ];
        state.addReceiver.data = data;
        state.addReceiver.loading = false;
        state.addReceiver.error = null;
      })
      .addCase(verifyReceiverInfo.pending, (state) => {
        state.verifyReceiver.loading = true;
        state.verifyReceiver.error = null;
      })
      .addCase(verifyReceiverInfo.rejected, (state, action) => {
        state.verifyReceiver.loading = false;
        state.verifyReceiver.error = action.payload;
      })
      .addCase(verifyReceiverInfo.fulfilled, (state, action) => {
        state.currentUser.user.verified_receivers = [
          ...state.currentUser.user.verified_receivers,
          { ...action?.payload },
        ];
        state.verifyReceiver.loading = false;
        state.verifyReceiver.error = null;
      })
      .addCase(sendVerifyCode.pending, (state) => {
        state.sendVerifyCodeAgain.loading = true;
        state.sendVerifyCodeAgain.error = null;
      })
      .addCase(sendVerifyCode.rejected, (state, action) => {
        state.sendVerifyCodeAgain.loading = false;
        state.sendVerifyCodeAgain.error = action.payload;
      })
      .addCase(sendVerifyCode.fulfilled, (state, action) => {
        state.addReceiver.data.request_id = action?.payload?.request_id;
        state.sendVerifyCodeAgain.loading = false;
        state.sendVerifyCodeAgain.error = null;
      })
      .addCase(destroyReceiver.pending, (state) => {
        state.removeReceiver.loading = true;
        state.removeReceiver.error = null;
      })
      .addCase(destroyReceiver.rejected, (state, action) => {
        state.removeReceiver.loading = false;
        state.removeReceiver.error = action.payload;
      })
      .addCase(destroyReceiver.fulfilled, (state, action) => {
        state.currentUser.user.verified_receivers =
          state.currentUser.user.verified_receivers.filter(
            (item) => item?.id != action?.payload
          );
        state.removeReceiver.loading = false;
        state.removeReceiver.error = null;
      });
  },
});

export const { switchToHijackerUser, clearCurrentUser, setCurrentUser } =
  accountSlice.actions;
